/**
 * API Configuration for TraderTekno
 * Centralized API URL management based on environment
 */

export const getAPIUrl = (): string => {
  // Check environment variable first
  const envApiUrl = import.meta.env.VITE_API_URL as string | undefined;
  if (envApiUrl) {
    return envApiUrl;
  }

  // Auto-detect environment based on current domain
  const currentHost = typeof window !== 'undefined' ? window.location.hostname : '';
  
  // New tradertekno.trade architecture
  if (currentHost === 'app.tradertekno.trade') {
    return 'https://api.tradertekno.trade';
  }
  if (currentHost === 'staging.tradertekno.trade') {
    return 'https://api-staging.tradertekno.trade';
  }
  if (currentHost === 'admin.tradertekno.trade') {
    return 'https://api.tradertekno.trade';
  }
  if (currentHost === 'admin-staging.tradertekno.trade') {
    return 'https://api-staging.tradertekno.trade';
  }

  // Fallback based on environment variable
  const environment = import.meta.env.VITE_ENVIRONMENT as string || 'staging';
  
  switch (environment) {
    case 'production':
      return 'https://api.tradertekno.trade';
    case 'staging':
    default:
      // Default to staging for development and fallback
      return 'https://api-staging.tradertekno.trade';
  }
};

// Lazy initialization to avoid circular dependency issues
export const API_CONFIG = {
  get baseURL() {
    return getAPIUrl();
  },
  timeout: 30000, // 30 seconds
  headers: {
    'Content-Type': 'application/json',
  }
};

// Helper function to build API endpoints
export const buildApiUrl = (path: string): string => {
  const baseUrl = getAPIUrl();
  // Ensure no double slashes
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${cleanPath}`;
};